import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LockerMapMobile from "../components/LockerMapMobile";
import CircularProgressLoader from "../components/CircularProgressLoader";
import ShowToast from "../components/ToastComponent";
import { TOAST_ERROR } from "../assets/constants/Constants";
import {
  fetchNearbyLockersForLocation,
  getCurrentBrowserLocation,
  getNearbyLockerErrorMessage,
} from "../lib/NearbyLockerUtils";

const LockerMapPreviewPage = () => {
  const [isMapReady, setIsMapReady] = useState(false);
  const [showLoader, setShowLoader] = useState(true);
  const [loadingMessage, setLoadingMessage] = useState("");
  const isFindingLockersRef = useRef(false);
  const { t } = useTranslation();
  const history = useHistory();

  useEffect(() => {
    const findLockersForCurrentLocation = async () => {
      if (isFindingLockersRef.current) {
        return;
      }

      isFindingLockersRef.current = true;
      setShowLoader(true);
      setLoadingMessage(t("info_Message_Getting_Location"));

      try {
        const userLocation = await getCurrentBrowserLocation();
        const { lockersData: apiData } = await fetchNearbyLockersForLocation({
          userLocation,
          onLoadingMessage: setLoadingMessage,
        });

        history.replace({
          pathname: history.location.pathname,
          state: {
            center: userLocation,
            useUserLocation: true,
            lockersData: apiData,
            timestamp: Date.now(),
          },
        });
        setIsMapReady(true);
      } catch (error) {
        console.log("Nearby locker flow error:", error);
        const message = getNearbyLockerErrorMessage(error);
        ShowToast(message, TOAST_ERROR);
      } finally {
        setShowLoader(false);
        isFindingLockersRef.current = false;
      }
    };

    findLockersForCurrentLocation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="locker-map-preview-page">
      {isMapReady && <LockerMapMobile />}
      {showLoader && <CircularProgressLoader message={loadingMessage} />}
    </div>
  );
};

export default LockerMapPreviewPage;
